export const fileDownload = function (data: any, filename: string, mime?: any) {
	const blob = new Blob([data], { type: mime || 'application/octet-stream' });
	if (typeof window.navigator.msSaveBlob !== 'undefined') {
		window.navigator.msSaveBlob(blob, filename);
	}
	else {
		const blobURL = window.URL.createObjectURL(blob);
		const tempLink = document.createElement('a');
		tempLink.style.display = 'none';
		tempLink.href = blobURL;
		tempLink.setAttribute('download', filename);

		if (typeof tempLink.download === 'undefined') {
			tempLink.setAttribute('target', '_blank');
		}

		document.body.appendChild(tempLink);
		tempLink.click();
		document.body.removeChild(tempLink);
		window.URL.revokeObjectURL(blobURL);
	}
};

export const downloadFromAxiosResponse = function (axiosResponse: any, defaultFilename: any) {
	const contentDisposition = axiosResponse.headers['content-disposition'];

	let fileName = defaultFilename;
	if (contentDisposition) {
		const fileNameMatch = contentDisposition.match(/filename=(.+);/);
		if (fileNameMatch.length === 2)
			fileName = fileNameMatch[1];
	}
	fileDownload(axiosResponse.data, fileName);
};
